<template>
  <multiselect
    v-bind="$attrs"
    :multiple="multiple"
    :options="options"
    :placeholder="placeholder"
    :searchable="searchable"
    :show-labels="false"
    :track-by="trackBy"
    :value="selected"
    class="position-relative"
    label="name"
    @input="input"
    @select="$emit('select')"
  >
    <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
      <slot v-bind="scope" :name="slot" />
    </template>
  </multiselect>
</template>
<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  props: {
    options: {
      required: true,
    },
    trackBy: {
      type: String,
      default: 'id',
    },
    value: {
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '-',
    },
  },
  data() {
    return {
      selected: null,
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal === null) {
          this.selected = null
          return
        }

        if (this.$attrs['group-values']) {
          let newOptions = this.options
          let start = 0
          newOptions.map((i) => {
            i.values.map((v) => {
              v.select_id = ++start
            })
          })
          this.trackBy = 'select_id'
          this.options = newOptions
        } else {
          if (this.multiple) {
            this.selected = []
            for (let item of this.options) {
              if (newVal.includes(item[this.trackBy])) {
                this.selected.push(item)
              }
            }
          } else {
            this.selected = this.options.filter(
              (x) => x[this.trackBy] === newVal,
            )
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    input(value) {
      this.selected = value
      if (this.$attrs['group-values']) {
        let groupedValues = {}
        for (let o of this.options) {
          groupedValues[Object.keys(o)[0]] = o.values
            .filter((item) => {
              for (let v of value) {
                if (v.select_id === item.select_id) return true
              }
              return false
            })
            .map((val) => val.id)
        }
        this.$emit('input', value ? groupedValues : null)
      } else {
        let values = []
        if (this.multiple) {
          values = value.map((val) => val[this.trackBy])
        } else {
          values = value[this.trackBy]
        }
        this.$emit('input', value ? values : null)
      }
    },
  },
}
</script>
